export default "__VITE_ASSET__CgbzGEjs__"